import React from "react"
import badge from "badges/joining-forces.svg"
import { BadgeImage } from "backpack/badges/styled"

const JoiningForces = props => <BadgeImage src={badge} {...props} />

export default JoiningForces
